import { SYSAction } from "../../../../../../_ovlclient/src/index"
import { Data } from "../../../../../../_ovlclient/src/dataapi"
import { FeatureGet } from "../../../../../../_ovlclient/src/global/globalapi"
import { ProcessStart, ProcessEnd } from "../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"

const FetchKPIData: SYSAction<{ kpiCode: string; viewType: string; filterCardCode?: string }> = async (
  value,
  { global }
) => {
  const code = value.kpiCode
  const viewType = value.viewType
  const kpiFeatureState = global.getState().app.features.KPI

  // Initialize viewType state if it doesn't exist
  if (!kpiFeatureState.data[viewType]) {
    kpiFeatureState.data[viewType] = {}
  }

  const viewData = kpiFeatureState.data[viewType]

  // Initialize state for this KPI if it doesn't exist
  if (!viewData[code]) {
    viewData[code] = {
      loading: true,
      error: "",
      result: null,
    }
  } else {
    viewData[code].loading = true
    viewData[code].error = ""
  }

  try {
    const payload: any = { kpiCode: code, viewType: viewType }
    if (value.filterCardCode) {
      payload.filterCardCode = value.filterCardCode
    }
    const response = await Data("kpi/getdata", payload)
    if (response.status >= 200 && response.status < 300) {
      viewData[code].result = response.data
    } else {
      viewData[code].error =
        response.message ||
        `Failed to load KPI data (Status: ${response.status})`
    }
  } catch (e: any) {
    viewData[code].error = e.message || "An error occurred"
  } finally {
    viewData[code].loading = false
  }
}

const FetchAllKPIData: SYSAction<{ viewType: string; filterCardCode?: string }> = async (
  value,
  { global }
) => {
  const kpiFeature = FeatureGet("KPIUser")
  if (kpiFeature.Found()) {
    const kpiConfigs = kpiFeature.GetJson1Parsed() as any
    const viewConfig = kpiConfigs[value.viewType]

    if (viewConfig) {
      ProcessStart("KPIDataRefresh")
      try {
        const promises = Object.keys(viewConfig)
          .filter((code) => viewConfig[code].enabled)
          .map((code) =>
            global.getActions().app.features.KPI.actions.FetchKPIData({
              kpiCode: code,
              viewType: value.viewType,
              filterCardCode: value.filterCardCode,
            })
          )

        await Promise.all(promises)
      } finally {
        ProcessEnd("KPIDataRefresh")
      }
    }
  }
}

export let actions = {
  FetchKPIData,
  FetchAllKPIData,
}
